import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ThePaawanManifesto() {
  const {
    ref: titleRef,
    isVisible: isTitleVisible
  } = useRevealOnScroll();
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.5
  });
  return <section id="the-pāawan-manifesto" className="bg-background relative w-full overflow-hidden py-32 md:py-48 lg:py-64">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-accent)_0%,transparent_40%)] opacity-20 blur-3xl" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center justify-center text-center">
          
          {}
          <div ref={titleRef} className={cn("transition-all duration-1000 ease-out transform", isTitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
            <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl text-foreground tracking-tight mb-6 leading-tight">
              पावन पवन, उत्तम जीवन
            </h2>
            <p className="font-sans text-lg md:text-2xl text-muted-foreground tracking-wide uppercase opacity-80">
              Pure air, better life
            </p>
          </div>

          {}
          <div className="h-24 md:h-32 lg:h-40" aria-hidden="true" />

          {}
          <div ref={textRef} className={cn("max-w-[500px] mx-auto transition-all duration-1000 ease-out delay-300 transform", isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
            <p className="font-sans text-lg md:text-xl leading-relaxed text-foreground/80">
              Clean air is not a luxury; it is a fundamental human right. We
              believe in creating environments where every breath is pure,
              sun-lit, and revitalizing. By stripping away the invisible burdens
              of modern pollution, we reveal the sanctity of life itself—giving
              you the room to truly breathe.
            </p>
          </div>
          
        </div>
      </div>
    </section>;
}